import { render, staticRenderFns } from "./HardwareBlockEditor.vue?vue&type=template&id=413f700f&scoped=true&"
import script from "./HardwareBlockEditor.vue?vue&type=script&lang=js&"
export * from "./HardwareBlockEditor.vue?vue&type=script&lang=js&"
import style0 from "./HardwareBlockEditor.vue?vue&type=style&index=0&id=413f700f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f700f",
  null
  
)

export default component.exports